import { cn } from "@/utils";

export const FreshenerSideBySide = ({ item, size, onClick }) => {
  const sizeClasses = size === "small" ? "h-10 w-10 lg:h-10 lg:w-10" : "";

  return (
    <div className="flex gap-2">
      {item.design.front_proof ? (
        <img
          src={item.design.front_proof}
          className={cn(
            "w-[50px] max-h-[70px] lg:w-[140px] lg:max-h-[188px] cursor-pointer rounded-md object-contain max-w-[unset]",
            sizeClasses
          )}
          onClick={onClick}
        />
      ) : (
        <div
          className={cn(
            "w-[50px] h-[70px] lg:w-[140px] lg:h-[180px] rounded-md bg-gray-300",
            sizeClasses
          )}
        />
      )}
      {item.design.back_proof ? (
        <img
          src={item.design.back_proof}
          className={cn(
            "w-[50px] max-h-[70px] lg:w-[140px] lg:max-h-[188px] cursor-pointer rounded-md object-contain max-w-[unset]",
            sizeClasses
          )}
          onClick={onClick}
        />
      ) : (
        <div
          className={cn(
            "w-[50px] h-[70px] lg:w-[140px] lg:h-[180px] rounded-md bg-gray-300",
            sizeClasses
          )}
        />
      )}
    </div>
  );
};
